import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    shippingMethods: [],
    status: 'idle',
    error: null,
    defaultShippingCost: 120, // Fallback
    freeShippingThreshold: 2500, // Fallback
    shippingRates: [], // Store tiered rates
    headerSettings: {
        phone_enabled: true,
        phone_number: '+52 55 1234 5678',
        currency_enabled: true,
        currency_default: 'MXN',
        currency_symbol: '$'
    }
};

export const fetchShippingMethods = createAsyncThunk(
    'settings/fetchShippingMethods',
    async () => {
        const response = await axios.get('/api/shipping-methods');
        return response.data;
    }
);

export const fetchHeaderSettings = createAsyncThunk(
    'settings/fetchHeaderSettings',
    async () => {
        const response = await axios.get('/api/settings/header');
        return response.data;
    }
);

const settingSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        // ...
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchShippingMethods.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShippingMethods.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.shippingMethods = Array.isArray(action.payload) ? action.payload : [];
                
                // Usar el primer método activo para configurar los costos globales
                // Esto asume que solo hay un método de envío principal activo por ahora
                const activeMethod = Array.isArray(action.payload) ? action.payload.find(m => m.is_active) : null;
                if (activeMethod) {
                    state.defaultShippingCost = Number(activeMethod.cost);
                    state.freeShippingThreshold = activeMethod.free_shipping_threshold ? Number(activeMethod.free_shipping_threshold) : null;
                    state.shippingRates = activeMethod.rates || [];
                }
            })
            .addCase(fetchShippingMethods.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(fetchHeaderSettings.fulfilled, (state, action) => {
                state.headerSettings = action.payload;
            });
    }
});

export default settingSlice.reducer;
